import { render, staticRenderFns } from "./CreateWalletInputFooter.vue?vue&type=template&id=38e3e4d4&scoped=true&functional=true&"
import script from "./CreateWalletInputFooter.vue?vue&type=script&lang=js&"
export * from "./CreateWalletInputFooter.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletInputFooter.vue?vue&type=style&index=0&id=38e3e4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "38e3e4d4",
  null
  
)

export default component.exports